import { Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { formatAppDate } from '../../date/app-date-format';
import { RedSchedulerClaimService } from '../red-scheduler-claim.service';

/**
 * "RED scheduling is held by this backend until 15:30" — shown app-wide while
 * the signed-in staff member holds the RED scheduler claim (`~redclaim`), so
 * it isn't forgotten: meanwhile every other backend skips RED's proposals and
 * snapshots. Not translated, like the `~` dev menu it belongs to: only Anessa
 * staff can claim.
 */
@Component({
  selector: 'app-red-scheduler-claim-banner',
  imports: [MatIconModule],
  templateUrl: './red-scheduler-claim-banner.html',
  styleUrl: './red-scheduler-claim-banner.scss',
})
export class RedSchedulerClaimBanner {
  private readonly claims = inject(RedSchedulerClaimService);

  readonly message = computed(() => {
    const claim = this.claims.myClaim();
    if (!claim) return '';
    const until = formatAppDate(claim.expiresAt, 'time');
    if (!claim.heldByThisBackend) {
      // Usually this backend before a restart (`nx serve` restarts on save).
      return (
        `RED scheduling is held by another backend of yours until ${until}, so this one skips RED ` +
        'proposals and snapshots too: run ~redclaim to take it over here.'
      );
    }
    return `RED scheduling is held by this backend until ${until}: other backends skip RED proposals and snapshots meanwhile.`;
  });

  protected release(): void {
    this.claims.release().subscribe();
  }
}
